import useMouse from "@react-hook/mouse-position"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"
import React, { useRef } from "react"
import { useWindowSize } from "react-use"

import { GalleryZoomPictureItem } from "../../model/gallery-item"
import "./lightbox-zoom-picture.sass"

const LightboxZoomPicture = ({ galleryPicture }) => {
  const ref = useRef()

  const mousePos = useMouse(ref, {
    enterDelay: 100,
    leaveDelay: 100,
  })

  const aspectRatio = galleryPicture.height / galleryPicture.width
  const { width, height } = useWindowSize()

  let style = {}

  let zoomLensStyle = {
    top: mousePos.y,
    left: mousePos.x,
    display: (!mousePos || mousePos.x) === null ? "none" : "block",
    background: `url(${galleryPicture.zoomedImageSrc})`,
    backgroundPositionX: mousePos.x * -2,
    backgroundPositionY: mousePos.y * -2,
  }

  if (aspectRatio > height / width) {
    // Portrait
    style.height = height * 0.8
    style.margin = "0 auto"
    style.width = style.height * (1 / aspectRatio)
  } else {
    // Landscape
    style.width = width * 0.8
    style.height = style.width * aspectRatio
  }

  return (
    <div className="_fp-lightbox-zoom-picture">
      <div className="_fp-lightbox-zoom-picture__image" style={style} ref={ref}>
        <GatsbyImage image={galleryPicture.gatsbyFluidImage} />

        <div
          className="_fp-lightbox-zoom-picture__zoom-lens"
          style={zoomLensStyle}
        />
      </div>
    </div>
  )
}

LightboxZoomPicture.propTypes = {
  galleryPicture: PropTypes.instanceOf(GalleryZoomPictureItem).isRequired,
}

export default LightboxZoomPicture
